const sm = "h-3.5 w-3.5 shrink-0 text-muted-foreground/70";

const md = "h-4 w-4 shrink-0 text-muted-foreground";

export { sm, md };
